import { createApi } from '@reduxjs/toolkit/query/react';
import createBaseQuery from '../../utils/baseQuery';

const baseQueryWithReAuth = createBaseQuery('user');


export const profileApiSlice = createApi({
  reducerPath: 'profileApi',
  baseQuery: baseQueryWithReAuth,
  tagTypes: ['Profiles', 'Password'],
  endpoints: (builder) => ({
    getProfileData: builder.query({
      query: ({ page, limit, searchTerm }) => ({
        url: '/get-relevant-users',
        method: 'POST',
        body: { page, limit, searchTerm },
      }),
      providesTags: ['Profiles'],
    }),
    updatePassword: builder.mutation({
      query: ({ newPassword, oldPassword }) => ({
        url: '/update-user-password',
        method: 'PUT',
        body: {
          newPassword,
          oldPassword
        }
      }),
      invalidatesTags: ['Password']
    }),
    updateUserProfile: builder.mutation({
      query: (updateData) => ({
        url: '/update-user-profile',
        method: 'PUT',
        body: updateData
      }),
      invalidatesTags: ['Profiles']
    }),

  })
});

export const {
  useGetProfileDataQuery,
  useUpdatePasswordMutation,
  useUpdateUserProfileMutation,
} = profileApiSlice;
